import React from "react";
import { Button } from "antd";
import SearchResult from "../../SearchResult";
import SortOption from "../../../../components/SortOption";
import styles from "./headerDesktop.scss";
import { getIconUrl } from "../../../../services/asset";

const HeaderDesktop = ({
  loading,
  filters,
  ads,
  onSave,
  hasSaveButton,
  onSortClick,
  sortOption,
  metaData,
  categoryName
}) => (
  <div className={styles.header}>
    <div className={styles.body}>
      {loading
        ? <span className={styles.skeletonLoaderHeading}></span>
        : filters && (
            <SearchResult
              ads={ads}
              metaData={metaData}
              className={styles.searchResult}
              categoryName={categoryName}
            />
          )}
      <div className={styles.buttons}>
        {!hasSaveButton ? null : (
          <Button size="large" onClick={onSave}>
            <img
              alt={"Spremi"}
              src={getIconUrl("notification.svg")}
            />
            {"Spremi"}
          </Button>
        )}
        <SortOption
          onSortClick={onSortClick}
          selectedOption={sortOption}
          classNameDesktop={!hasSaveButton ? "" : styles.sortOption}
        />
      </div>
    </div>
  </div>
);

export default HeaderDesktop;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchSection/HeaderDesktop/HeaderDesktop.tsx